class Wishlist extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const data = this.dataset;
    const login = data.login === "true";
    document.addEventListener("DOMContentLoaded", ()=> {
      this.loadInitialLikes(data, login)
    })

    this.isLoading = false
  }

 //pega a lista de produtos curtidos
  async getLikedProductIds(data, login) {
    if(login) {
      const response = await this.getWishlist(data);
      let likedProductIds = []
      response.products.map((item)=>{
        likedProductIds.push(item.productId)
      })
      return likedProductIds;
    } else {
      const likedProductIds = JSON.parse(localStorage.getItem("productIds")) || [];
      return likedProductIds;
    }
  }

  //verifica quais produtos foram curtidos na página
  async loadInitialLikes(data, login) {
    if(login) {
      await this.saveLocalStorageToPrisma(data);
    }
    const likedProductIds = await this.getLikedProductIds(data, login);
    
    likedProductIds.forEach((productId) => {
      const element = document.querySelector(`[data-id-product="${productId}"]`);
      if (element) {
        this.handleHearts(element, true)
      } else {
        console.log("Nenhum elemento encontrado!");
      }
    });

    this.onClickHeart(data, login)
  }

  //salva do localstorage para o banco de dados
  // salva os produtos do localStorage no banco (Prisma) ao logar
  async saveLocalStorageToPrisma(data) {
    try {
      const productIds = JSON.parse(localStorage.getItem("productIds")) || [];
      if (productIds.length === 0) return;

      for (const productId of productIds) {
        const responsePrisma = await fetch(
          `${data.apiUrl}/api/wishlist?productId=${productId}&customerId=${data.customerId}&shop=${data.shop}`,
          {
            method: "GET",
          }
        );

        const json = await responsePrisma.json();

        // só adiciona se não existir
        if (!json.exists) {
          const response = await fetch(
            `${data.apiUrl}/api/wishlist?productId=${productId}&customerId=${data.customerId}&shop=${data.shop}`,
            {
              method: "POST",
              body: JSON.stringify({ methodW: "POST" }),
            }
          );

          if (!response.ok) {
            throw new Error(`Erro ao adicionar produto ${productId}: ${response.statusText}`);
          }
        }
      }

      localStorage.removeItem("productIds");
      console.log("Produtos migrados do localStorage para o Prisma.");
    } catch (error) {
      console.error("Erro ao salvar do localStorage para o Prisma:", error);
    }
  }


  //verifica se produto está curtido
  async isProductLiked(productId, data, login) {
    const liked = await this.getLikedProductIds(data, login);
    return liked.includes(productId);
  }

  //marca ou desmarca o coração
  handleHearts(element, isLiked) {
    const heartUnchecked = element.querySelector(".iconHeartUnchecked");
    const heartChecked = element.querySelector(".iconHeartChecked");

    if (heartChecked && heartUnchecked) {
      heartChecked.style.display = isLiked ? "block" : "none";
      heartUnchecked.style.display = isLiked ? "none" : "block";
    }
  }

  //clique no coração
  onClickHeart(data, login) {
    document.querySelectorAll(".iconHeart").forEach((element) => {
      element.addEventListener("click", async () => {
        const productId = element.dataset.idProduct;
        let isLiked = await this.isProductLiked(productId, data, login) || false;

        if(login){
          if(this.isLoading) return;
          this.isLoading = true;

          if(isLiked) {
            await this.deleteProductsInPrisma(data, productId);
            isLiked = false;
          } else {
            await this.addProductsInPrisma(data, productId);
            isLiked = true;
          }
          
        } else {
          if(isLiked) {
            this.deleteProductsInLocalStorage(productId)
            isLiked = false;
          } else {
            this.addProductsInLocalStorage(productId);
            isLiked = true;
          }
        }

        //atualiza o coração
        this.handleHearts(element, isLiked);
      })
    })
  }

  //requisições
  async getWishlist(data) {
    const getResponse = await fetch(
      `${data.apiUrl}/api/wishlist?productId=7552954105910&customerId=7165326852150&shop=${data.shop}`,
      {
        method: "GET",
      },
    );
    const response = await getResponse.json();
    return response;
  }
  
  //adiciona ao prisma
  async addProductsInPrisma(data, productId) {
    try {
      const response = await fetch(
        `${data.apiUrl}/api/wishlist?productId=${productId}&customerId=7165326852150`,
        {
          method: "POST",
          body: JSON.stringify({ methodW: "POST" }),
        },
      );
      this.isLoading = false;
      return response;
    } catch (error) {
      console.error("error POST");
      this.isLoading = false;
    }
  }

  //adiciona ao localStorage
  addProductsInLocalStorage(productId) {
    console.log(productId, "<<D<adas,das,da,sda,s")
    let productIds = JSON.parse(localStorage.getItem("productIds")) || [];
    productIds.push(productId);
    localStorage.setItem("productIds", JSON.stringify(productIds));
  }

  //deleta do prisma
  async deleteProductsInPrisma(data, productId) {
    try {
      const response = await fetch(
        `${data.apiUrl}/api/wishlist?productId=${productId}&customerId=7165326852150`,
        {
          method: "POST",
          body: JSON.stringify({ methodW: "DELETE" }),
        },
      );
      this.isLoading = false;
      return response;
    } catch (error) {
      console.error("error DELETE");
      this.isLoading = false;
    }
  }

  //deleta do localStorage
  deleteProductsInLocalStorage(productId) {
    let productIds = JSON.parse(localStorage.getItem("productIds")) || [];
    productIds = productIds.filter(id => id !== productId);
    localStorage.setItem("productIds", JSON.stringify(productIds));
  }
}

customElements.define("wishlist-lel", Wishlist);
